module.exports = __webpack_public_path__ + "turkey.svg?30802ce69ee0f2efd1f6eb0374d129d9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/turkey.svg
// module id = 324
// module chunks = 10